import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/ab-tests/new')({

}).lazy(() => import('./new.lazy').then((d) => d.Route));
